import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-download-the-app-now',
  imports: [TranslatePipe],
  templateUrl: './download-the-app-now.html',
  styleUrl: './download-the-app-now.scss',
})
export class DownloadTheAppNow {}
